;(function (angular) {
  'use strict'

  angular
    .module('kilo.routes.entity', [
      'kilo.routes.entity.show',
      'kilo.routes.entity.list'
    ])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider']

  function RouteConfigurator ($stateProvider) {
    var parentState = {
      name: 'entity',
      url: '/entity',
      resolve: {},
      abstract: true
    }

    $stateProvider.state(parentState)
  }
})(window.angular)
